import { LightningElement, wire } from "lwc";

import { LabelTranslations, MultiLabelAdapter } from "tbme/localization";
import { CardState } from "elements/tbui/card/types";

import { QueryAdapter, QueryAdapterValue } from "tbme/queryAdapter";
import { USER_DETAILS_QUERY } from "./query";
import {
  GetUserDetails,
  GetUserDetails_chassis_profile,
} from "./gql/GetUserDetails";
import {
  countryOptions,
  getCountryLabel,
  getStateLabel,
  stateOptions,
} from "../../../shared/countryOptions";

export type UserDetails = Omit<GetUserDetails_chassis_profile, "__typename">;

export default class extends LightningElement {
  private isSelf: boolean = false;
  private user: UserDetails = undefined!;

  private cardState: CardState = "loading";
  private displayProfileEditModal: boolean = false;

  private labels: LabelTranslations = undefined!;

  handleEditDetails() {
    this.displayProfileEditModal = true;
  }

  handleProfileEditRequestClose() {
    this.displayProfileEditModal = false;
  }

  get userCountry(): string {
    return getCountryLabel(this.user?.address?.country) || "";
  }

  get userState(): string {
    return (
      getStateLabel(this.user?.address?.country, this.user?.address?.state) ||
      ""
    );
  }

  @wire(QueryAdapter, { query: USER_DETAILS_QUERY })
  private handleResult(result: QueryAdapterValue<GetUserDetails>) {
    const { data, loading, error, errors } = result;

    if (loading && !data?.chassis?.profile) {
      this.cardState = "loading";
      return;
    }

    if (error || errors) {
      this.cardState = "loadFailed";
      return;
    }

    if (!data?.chassis?.profile) {
      return;
    }

    this.cardState = "default";
    this.isSelf = data.chassis.isSelf;
    this.user = { ...data.chassis.profile } as UserDetails;
  }

  @wire(MultiLabelAdapter, {
    labels: [
      "userDetails.edit",
      "userDetails.title",
      "userDetails.subtitle",
      "userDetails.fieldRole",
      "profileEditModal.fieldPronoun",
      "profileEditModal.fieldCompanyName",
      "profileEditModal.fieldCompanySize",
      "profileEditModal.fieldCompanyWebsite",
      "profileEditModal.fieldCountryCode",
      "profileEditModal.fieldStateCode",
      "profileEditModal.fieldRelationshipToSalesforce",
    ],
  })
  private handleLabels({
    userDetails,
    profileEditModal,
  }: {
    userDetails: LabelTranslations;
    profileEditModal: LabelTranslations;
  }) {
    this.labels = {
      ...profileEditModal,
      ...userDetails,
    };
  }
}
